import { useLoanOfferFormContext } from '@sec-loans-ui/loan-offer/steps/formContext'
import { FormStep } from '@sec-loans-ui/loan-offer/steps/FormStep'
import { useWizardForm } from '@ui-common/hooks'
import { useIntl } from 'react-intl'

export const AfterCareStep = () => {
  const intl = useIntl()
  const { formatMessage } = intl
  const { proceed } = useLoanOfferFormContext()

  const methods = useWizardForm({
    defaultValues: {},
  })

  return (
    <FormStep
      allowBack={true}
      subHeader={formatMessage({ id: 'loan-offer-after-care-step-heading' })}
      formMethods={methods}
      onSubmit={proceed}
    />
  )
}
